<template>
  <Teleport defer :disabled="!teleportTo" :to="teleportTo">
    <div
      :class="[
        bannerClass,
        variantClass,
        teleportTo == '#full-top-alerts' ? 'm-2' : '',
      ]"
      class="justify-start flex items-center gap-x-6 px-6 py-2.5 sm:px-3.5 rounded"
    >
      <template v-if="simple">
        <slot></slot>
      </template>
      <template v-else>
        <div class="flex gap-[1em] items-center">
          <slot name="left">
            <v-icon
            v-if="icon"
            :name="icon"
            :class="iconClass"
            height="1em"
            width="1em"
          ></v-icon>
          </slot>
          <div class="block">
            <slot></slot>
          </div>
        </div>

        <div class="flex flex-0" v-if="hasClose">
          <button
            type="button"
            class="-m-3 p-3 focus-visible:outline-offset-[-4px]"
          >
            <span class="sr-only">Dismiss</span>
            <v-icon name="io-close" />
          </button>
        </div>
      </template>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { computed } from "vue"

const props = withDefaults(
  defineProps<{
    hasClose?: boolean
    bannerClass?: string
    teleportTo?: string
    variant?: "info" | "warning-outline" | "info-outline"
    icon?: string
    iconClass?: string
    simple: boolean
    class?: string
  }>(),
  {},
)

const variantClasses = {
  info: "bg-sky-200 dark:bg-transparent text-sky-800 dark:text-sky-400 border-sky-300  dark:border-sky-600 border",
  'strong-error': "bg-error text-white",
  'error': "bg-rose-200 text-rose-700 border-rose-300 border dark:bg-transparent dark:border-rose-500 dark:text-rose-500",
  "error-outline": "text-error border-2 border-error",
  "info-outline": "border-2 border-info text-info",
  "warning-outline": "border-2 border-warning text-warning",
  'success': "bg-emerald-300 text-emerald-800 border border-emerald-400",
  blue: "bg-sky-200 text-sky-800 border border-sky-300 dark:bg-transparent dark:text-sky-400 dark:border-sky-600",
  red: "bg-rose-200 text-rose-700 border border-rose-300 dark:bg-transparent dark:text-rose-500 dark:border-rose-500",
  warning: "bg-amber-200 text-amber-800 border-amber-300 border dark:bg-transparent dark:border-amber-500 dark:text-amber-500 [&_button]:!bg-amber-600 [&_button]:!text-white [&_button]:border-amber-700 [&_button:hover]:!bg-amber-700 dark:[&_button]:!bg-amber-600 dark:[&_button]:!text-zinc-900 dark:[&_button]:border-amber-700 dark:[&_button:hover]:!bg-amber-700",
  yellow: "bg-amber-200 text-amber-800 border border-amber-300 dark:bg-transparent dark:text-amber-400 dark:border-amber-500",
}

const variantClass = computed(() => {
  return variantClasses[props.variant] ?? ""
})
</script>
